import { Component, OnInit } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChangeDetectorRef } from '@angular/core';
import { dateTimeOperators, daysSelection } from 'globals/constants';
import _ from 'lodash-es';
import { MatFormField, MatLabel, MatSuffix, MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker, MatDateRangeInput, MatStartDate, MatEndDate, MatDateRangePicker } from '@angular/material/datepicker';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgSelectComponent } from '@ng-select/ng-select';

type FormlyValueChangeEvent = {
  field: FormlyFieldConfig;
  type: string;
  value: any;
  [meta: string]: any;
};

@Component({
    selector: 'app-generic-date-setter',
    templateUrl: './generic-date-setter.component.html',
    styleUrls: ['./generic-date-setter.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatDatepickerInput, NgxIntlTelInputModule, MatDatepickerToggle, MatSuffix, MatDatepicker, MatDateRangeInput, MatStartDate, MatEndDate, MatDateRangePicker, MatSelect, MatOption, NgSelectComponent]
})

export class GenericDateSetterComponent extends FieldType implements OnInit {
  private readonly onDestroy$ = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef) {
    super();
  }
  
  selectedOperator = null;
  previousSelectedOperator = null;
  daysSelectionOptions = daysSelection
  selectedNumber;
  selectedUnit;

  selectedDate;
  startDate;
  endDate;
  selectedHourOfDay;

  dateTimeOperators = _.cloneDeep(dateTimeOperators);


  ngOnInit(): void {
    console.log("options are ", this.to)
    this.options.fieldChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((event: FormlyValueChangeEvent) => {
        this.onFieldChange(event);
      });

  }

  onFieldChange(event: FormlyValueChangeEvent) {
    // console.log(`FormlyValueChangeEvent event is :`, event);
    // console.log("in GenericDateSetterComponent : model is ", this.model)
    this.previousSelectedOperator = this.selectedOperator;
    this.selectedOperator = this.model.operator;
    console.log("selected operator is ", this.selectedOperator);
    if(this.selectedOperator != this.previousSelectedOperator){
      this.cdr.detectChanges();
    }
    // handling of default values
    if(this.selectedOperator){
      const parts = this.selectedOperator?.split('##');
      if (parts && parts.length === 2) {
        if (parts[0] === "inPeriod"){
          if (parts[1] === "today"){
            if (this.field && this.field.templateOptions) {
              this.formControl.setValue({value : 0, type : "DAY"});
            }
          }
          else if (parts[1] === "yesterday"){
            if (this.field && this.field.templateOptions) {
              this.formControl.setValue({value : -1, type : "DAY"});
            }
          }
          else if (parts[1] === "week"){
            if (this.field && this.field.templateOptions) {
              this.formControl.setValue({value : 0, type : "WEEK"});
            }
          }
          else if (parts[1] === "lastWeek"){
            if (this.field && this.field.templateOptions) {
              this.formControl.setValue({value : -1, type : "WEEK"});
            }
          }
          else if (parts[1] === "month"){
            if (this.field && this.field.templateOptions) {
              this.formControl.setValue({value : 0, type : "MONTH"});
            }
          }
          else if (parts[1] === "lastMonth"){
            if (this.field && this.field.templateOptions) {
              this.formControl.setValue({value : -1, type : "MONTH"});
            }
          }
        }
      }
    }
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onNumberChange(ev){
    if (this.field && this.field.templateOptions) {
      if(this.selectedOperator == 'inPeriod##last' || this.selectedOperator == 'notInPeriod##last')
        this.formControl.setValue({value : -1 * this.selectedNumber, unit : this.selectedUnit, type : "DAY"});
      else
        this.formControl.setValue({value : this.selectedNumber, unit : this.selectedUnit, type : "DAY"});
    }
  }

  dateModified(){
    if (this.field && this.field.templateOptions) {
      this.formControl.setValue(this.selectedDate.toISOString());
    }
  }

  rangeDateModified(){
    if (this.field && this.field.templateOptions) {
      const startDate = this.startDate ? new Date(this.startDate) : null;
      const endDate = this.endDate ? new Date(this.endDate) : null;

      startDate?.setHours(0, 0, 0, 0);
      endDate?.setHours(23, 59, 59, 999);

      this.formControl.setValue([startDate?.toISOString(), endDate?.toISOString()]);
    }
  }

  onUnitChange(ev){
    if (this.field && this.field.templateOptions) {
      this.formControl.setValue({value : this.selectedNumber, unit : this.selectedUnit, type : "DAY"});
    }
  }

  onHourOfDayChange(ev){
    if (this.field && this.field.templateOptions) {
      this.formControl.setValue({value : this.selectedHourOfDay});
    }
  }

}
